/**
 * 将数值转换成中文 '0:未启/1:已启'
 * 
 * @param {*} val 数值
 * @param {*} map 值对
 * @return {string} 中文值
 */
export function dict(val, map) {
    let value = "";
    if (val && val.includes(",")) {
        value = val.split(",").map(item => pre(item, map)).join();
    } else {
        value = pre(val, map)
    }
    return value;
}

function pre(value, map) {
    if (value) {
        var val = Array.isArray(value) ? value : value.split(",");
        var maps = map?.split("/");
        var results = []; // 创建一个空数组，用于存储匹配到的值
        // 遍历 val 数组
        for (var j = 0; j < val?.length; j++) {
            var currentVal = val[j]; // 获取当前要查找的键
            for (var i in maps) {
                var kv = maps[i].split(":");
                if (kv[0] == currentVal) {
                    results.push(kv[1]); // 将匹配到的值添加到结果数组中
                    break; // 找到匹配项后，跳出内层循环
                }
            }
        }
        return results.length > 0 ? results.join() : "其他";
    }

}


/**
 * 1,2字符残疾类别转换
 * 
 * @param {*} val 数值
 * @return {string} 中文值
 */
export function analyType(val) {
    if (!val) {
        return ''
    }
    let newVal = ''
    let arr = ['视力', '听力', '言语', '肢体', '智力', '精神', '多重']
    for (let i = 1; i < 8; i++) {
        if (i === 1) {
            newVal = val.replace(i.toString(), arr[i - 1])
        } else {
            newVal = newVal.replace(i.toString(), arr[i - 1])
        }
    }
    return newVal;
}
export function analyLevel(val) {
    if (!val) {
        return ''
    }
    let newVal = ''
    let arr = ['一级', '二级', '三级', '四级', '不限等级']
    for (let i = 1; i < 7; i++) {
        if (i === 1) {
            newVal = val.replace(i.toString(), arr[i - 1])
        } else {
            newVal = newVal.replace(i.toString(), arr[i - 1])
        }
    }
    return newVal;
}